export const unitType = (units, type, format = "default") => {
    if (units === true) {
        switch (type) {
            case "length":
                return "inch";
            case "longlength":
                return "ft";
            case "square length":
                return "ft2";
            case "cubic length":
                return "MCF";
            case "volume":
                return "gal";
            case "velocity":
                return format === "ui" ? "inch/yr" : "inch_per_yr";
            case "velocity mils":
                return format === "ui" ? "mils/yr" : "mils_per_yr";
            case "temperature":
                return format === "ui" ? "°F" : "degrees_fahrenheit";
            case "pressure":
                return "psig";
            case "density":
                return "lb/gal";
            case "viscosity":
                return "m2/s";
            case "missingFeature":
                return "%";
            default:
                return null;
        }
    } else {
        switch (type) {
            case "length":
                return "mm";
            case "longlength":
                return "m";
            case "square length":
                return "m2";
            case "cubic length":
                return "m3";
            case "volume":
                return "L";
            case "velocity":
            case "velocity mils":
                return format === "ui" ? "mm/yr" : "mm_per_yr";
            case "temperature":
                return format === "ui" ? "°C" : "degrees_celcius";
            case "pressure":
                return "bar";
            case "density":
                return "kg/litre";
            case "viscosity":
                return "m2/s";
            case "missingFeature":
                return "%";
            default:
                return null;
        }
    }
};